const WEBSOCKET_SEARCH_PATTERNS = {
  HTTP: 'http://',
  HTTPS: 'https://',
  REST_API: '/rest/api'
}

const WEBSOCKET_REPLACE_VALUES = {
  DEFAULT: 'ws://',
  HTTPS: 'wss://',
  REST_API: '/ws'
}

const WEBSOCKET_URL_REPLACEMENT_OPTIONS = {}
WEBSOCKET_URL_REPLACEMENT_OPTIONS[WEBSOCKET_SEARCH_PATTERNS.HTTPS] = WEBSOCKET_REPLACE_VALUES.HTTPS
WEBSOCKET_URL_REPLACEMENT_OPTIONS[WEBSOCKET_SEARCH_PATTERNS.HTTP] = WEBSOCKET_REPLACE_VALUES.DEFAULT
WEBSOCKET_URL_REPLACEMENT_OPTIONS[WEBSOCKET_SEARCH_PATTERNS.REST_API] = WEBSOCKET_REPLACE_VALUES.REST_API

const HEADERS = {
  CLIENT_SESSION_ID: 'clientSessionId',
  AUTHORIZATION: 'Authorization'
}

const MAIN_REPLACEMENT_VARIABLES = {
  LOGIN_NAME: '$LOGIN_NAME'
}

export class SETTINGS {
  public static WEBSOCKET_URL_REPLACEMENT_OPTIONS = WEBSOCKET_URL_REPLACEMENT_OPTIONS
  public static HEADERS = HEADERS
  public static MAIN_REPLACEMENT_VARIABLES = MAIN_REPLACEMENT_VARIABLES
}
